import React from "react";
import "../About.css";
import Header from "../../../components/Header";
import Footer from "../../../components/Footer";
import { Link } from "react-router-dom";

import {
    FiChevronRight,
    FiShield,
    FiCheckCircle,
    FiLock,
    FiCpu,
    FiGlobe,
    FiTrendingUp,
} from "react-icons/fi";

const About = () => {
    return (
        <>
            <Header />

            <div className="about-page">

                {/*=====================================================
                        HERO SECTION
        ======================================================*/}

                <section className="about-hero">

                    <div className="container">

                        <div className="about-hero-content">

                            <span className="about-tag">
                                ABOUT SAIVARI FINTECH
                            </span>

                            <h1>
                                Building Trust Through
                                <span> Secure Financial Technology</span>
                            </h1>

                            <p>
                                Saivari Fintech Private Limited empowers banks, NBFCs,
                                payment providers, insurance companies, and fintech
                                startups with secure, scalable, and compliance-driven
                                auxiliary fintech services. We help organizations embrace
                                digital transformation while maintaining the highest
                                standards of security, regulatory compliance, and
                                operational excellence.
                            </p>

                            <div className="about-hero-buttons">

                                <a
                                    href="/contact"
                                    className="primary-about-btn"
                                >
                                    Get Consultation
                                </a>

                                {/* <Link
                                    to="/services"
                                    className="secondary-about-btn"
                                >
                                    Explore Services
                                </Link> */}

                            </div>

                        </div>

                    </div>

                </section>

                {/*=====================================================
                        BREADCRUMB
        ======================================================*/}

                <section className="about-breadcrumb">

                    <div className="container">

                        <Link to="/">Home</Link>

                        <FiChevronRight />

                        <span>About</span>

                    </div>

                </section>

                {/*=====================================================
                        WHO WE ARE
        ======================================================*/}

                <section className="who-we-are">

                    <div className="container">

                        {/* Left Dashboard */}

                        <div className="who-left">

                            <div className="about-dashboard">

                                <div className="dashboard-header">

                                    <h3>FinTech Operations</h3>

                                    <span className="dashboard-status">
                                        ● Secure
                                    </span>

                                </div>

                                <div className="dashboard-grid">

                                    <div className="dashboard-card">

                                        <FiShield />

                                        <h4>AML</h4>

                                        <span>Compliance Ready</span>

                                    </div>

                                    <div className="dashboard-card">

                                        <FiLock />

                                        <h4>KYC</h4>

                                        <span>Identity Verification</span>

                                    </div>

                                    <div className="dashboard-card">

                                        <FiCpu />

                                        <h4>Automation</h4>

                                        <span>AI Workflows</span>

                                    </div>

                                    <div className="dashboard-card">

                                        <FiGlobe />

                                        <h4>Cloud</h4>

                                        <span>Secure Infrastructure</span>

                                    </div>

                                </div>

                                {/* Floating Cards */}

                                {/* <div className="about-floating security-card">
                                    🛡 Enterprise Security
                                </div>

                                <div className="about-floating compliance-card">
                                    📜 Regulatory Compliance
                                </div>

                                <div className="about-floating analytics-card">
                                    📈 Smart Analytics
                                </div> */}

                            </div>

                        </div>

                        {/* Right Content */}

                        <div className="who-right">

                            <span className="section-tag">

                                WHO WE ARE

                            </span>

                            <h2>

                                Empowering Financial Institutions
                                <span> Through Technology</span>

                            </h2>

                            <p>

                                Saivari Fintech Private Limited is a trusted technology
                                partner delivering auxiliary fintech services that enable
                                financial institutions to operate securely, efficiently,
                                and in compliance with evolving regulatory standards.
                                We combine deep industry knowledge with modern digital
                                technologies to help organizations innovate confidently.

                            </p>

                            <p>

                                Our expertise spans FinTech consulting, AML managed
                                services, KYC verification, payment solutions,
                                third-party risk management, compliance support,
                                automation, cloud-native applications, and API
                                integrations. Every solution we deliver is designed to
                                improve operational efficiency while strengthening
                                security, compliance, and customer trust.

                            </p>

                            <div className="who-list">

                                <div>

                                    <FiCheckCircle />

                                    <span>Enterprise Security Standards</span>

                                </div>

                                <div>

                                    <FiCheckCircle />

                                    <span>AML & KYC Expertise</span>

                                </div>

                                <div>

                                    <FiCheckCircle />

                                    <span>Regulatory Compliance Solutions</span>

                                </div>

                                <div>

                                    <FiCheckCircle />

                                    <span>Digital Transformation Services</span>

                                </div>

                                <div>

                                    <FiCheckCircle />

                                    <span>Cloud & API Integration</span>

                                </div>

                                <div>

                                    <FiCheckCircle />

                                    <span>Scalable FinTech Infrastructure</span>

                                </div>

                            </div>

                            <div className="about-stats">

                                <div>

                                    <h3>100%</h3>

                                    <span>Compliance Focus</span>

                                </div>

                                <div>

                                    <h3>24×7</h3>

                                    <span>Technology Support</span>

                                </div>

                                <div>

                                    <h3>AI</h3>

                                    <span>Automation Ready</span>

                                </div>

                                <div>

                                    <h3>Cloud</h3>

                                    <span>Modern Infrastructure</span>

                                </div>

                            </div>

                        </div>

                    </div>

                </section>

                {/*=====================================================
                        OUR STORY
        ======================================================*/}

                <section className="our-story">

                    <div className="container">

                        <div className="section-heading">

                            <span className="section-tag">
                                OUR STORY
                            </span>

                            <h2>
                                Our Journey Towards
                                <span> FinTech Excellence</span>
                            </h2>

                            <p>
                                Our vision is to simplify financial technology through
                                secure, scalable, and compliance-driven solutions.
                                We continuously innovate to help financial institutions
                                embrace digital transformation with confidence.
                            </p>

                        </div>

                        <div className="timeline">

                            <div className="timeline-item">

                                <div className="timeline-year">
                                    2026
                                </div>

                                <div className="timeline-content">

                                    <h3>Company Founded</h3>

                                    <p>
                                        Saivari Fintech Private Limited was established
                                        with the mission of delivering trusted auxiliary
                                        fintech services for regulated financial
                                        institutions.
                                    </p>

                                </div>

                            </div>

                            <div className="timeline-item">

                                <div className="timeline-year">
                                    FinTech
                                </div>

                                <div className="timeline-content">

                                    <h3>Specialized Services</h3>

                                    <p>
                                        Expanded capabilities across AML managed services,
                                        KYC verification, payment solutions, compliance,
                                        and third-party risk management.
                                    </p>

                                </div>

                            </div>

                            <div className="timeline-item">

                                <div className="timeline-year">
                                    Innovation
                                </div>

                                <div className="timeline-content">

                                    <h3>Digital Transformation</h3>

                                    <p>
                                        Introduced cloud-native architecture, API
                                        integrations, intelligent automation, and secure
                                        digital platforms for financial organizations.
                                    </p>

                                </div>

                            </div>

                            <div className="timeline-item">

                                <div className="timeline-year">
                                    Future
                                </div>

                                <div className="timeline-content">

                                    <h3>Growing Together</h3>

                                    <p>
                                        Continuing to build secure, compliant, and
                                        innovative fintech ecosystems that help businesses
                                        scale confidently in a rapidly evolving financial
                                        landscape.
                                    </p>

                                </div>

                            </div>

                        </div>

                    </div>

                </section>

                {/*=====================================================
                    MISSION & VISION
        ======================================================*/}

                <section className="mission-vision">

                    <div className="container">

                        <div className="mission-card">

                            <div className="mission-icon">
                                🚀
                            </div>

                            <h3>Our Mission</h3>

                            <p>
                                To empower banks, NBFCs, payment providers, insurance
                                companies, and fintech startups with secure,
                                scalable, and compliance-focused technology solutions
                                that simplify operations, improve efficiency, and
                                accelerate digital transformation.
                            </p>

                        </div>

                        <div className="vision-card">

                            <div className="mission-icon">
                                🌍
                            </div>

                            <h3>Our Vision</h3>

                            <p>
                                To become a trusted global fintech technology partner
                                recognized for innovation, security, regulatory
                                excellence, and delivering sustainable digital
                                solutions that shape the future of financial services.
                            </p>

                        </div>

                    </div>

                </section>

                {/*=====================================================
                        CORE VALUES
        ======================================================*/}

                <section className="core-values">

                    <div className="container">

                        <div className="section-heading">

                            <span className="section-tag">
                                OUR CORE VALUES
                            </span>

                            <h2>

                                Principles That Drive
                                <span> Everything We Do</span>

                            </h2>

                            <p>

                                Every solution we build is guided by strong values,
                                ensuring long-term trust, innovation, and success for
                                our clients and partners.

                            </p>

                        </div>

                        <div className="values-grid">

                            <div className="value-card">

                                <div className="value-icon">🤝</div>

                                <h3>Integrity</h3>

                                <p>
                                    We believe in transparency, honesty, and building
                                    trusted long-term relationships with our clients.
                                </p>

                            </div>

                            <div className="value-card">

                                <div className="value-icon">💡</div>

                                <h3>Innovation</h3>

                                <p>
                                    We embrace emerging technologies to deliver
                                    intelligent and future-ready fintech solutions.
                                </p>

                            </div>

                            <div className="value-card">

                                <div className="value-icon">🛡</div>

                                <h3>Security</h3>

                                <p>
                                    Security is embedded into every solution to protect
                                    data, transactions, and customer trust.
                                </p>

                            </div>

                            <div className="value-card">

                                <div className="value-icon">📜</div>

                                <h3>Compliance</h3>

                                <p>
                                    We help organizations stay aligned with evolving
                                    financial regulations and industry standards.
                                </p>

                            </div>

                            <div className="value-card">

                                <div className="value-icon">🤝</div>

                                <h3>Collaboration</h3>

                                <p>
                                    We work closely with our clients to understand their
                                    goals and deliver measurable business outcomes.
                                </p>

                            </div>

                            <div className="value-card">

                                <div className="value-icon">⭐</div>

                                <h3>Customer Success</h3>

                                <p>
                                    Our clients' success is our success. We focus on
                                    delivering value that drives long-term growth.
                                </p>

                            </div>

                        </div>

                    </div>

                </section>

                {/*=====================================================
                        WHAT WE DO
        ======================================================*/}

                <section className="what-we-do">

                    <div className="container">

                        <div className="section-heading">

                            <span className="section-tag">
                                WHAT WE DO
                            </span>

                            <h2>
                                Comprehensive
                                <span> FinTech Services</span>
                            </h2>

                            <p>
                                We provide auxiliary fintech services that help financial
                                institutions modernize operations, strengthen compliance,
                                and accelerate secure digital transformation.
                            </p>

                        </div>

                        <div className="services-grid">

                            <div className="service-box">
                                <div className="service-icon">💼</div>
                                <h3>FinTech Consulting</h3>
                                <p>
                                    Strategic consulting to optimize digital financial
                                    operations and technology adoption.
                                </p>
                            </div>

                            <div className="service-box">
                                <div className="service-icon">💳</div>
                                <h3>Payment Solutions</h3>
                                <p>
                                    Secure payment infrastructure, gateway integration,
                                    reconciliation, and transaction monitoring.
                                </p>
                            </div>

                            <div className="service-box">
                                <div className="service-icon">🛡</div>
                                <h3>AML Managed Services</h3>
                                <p>
                                    Comprehensive anti-money laundering monitoring,
                                    reporting, and regulatory support.
                                </p>
                            </div>

                            <div className="service-box">
                                <div className="service-icon">✅</div>
                                <h3>KYC Verification</h3>
                                <p>
                                    Digital onboarding and identity verification solutions
                                    for financial institutions.
                                </p>
                            </div>

                            <div className="service-box">
                                <div className="service-icon">📋</div>
                                <h3>Compliance Support</h3>
                                <p>
                                    Helping organizations maintain compliance with
                                    financial regulations and industry standards.
                                </p>
                            </div>

                            <div className="service-box">
                                <div className="service-icon">⚠</div>
                                <h3>Third-Party Risk</h3>
                                <p>
                                    Vendor assessment, risk monitoring, governance,
                                    and operational resilience services.
                                </p>
                            </div>

                            <div className="service-box">
                                <div className="service-icon">⚡</div>
                                <h3>API Integration</h3>
                                <p>
                                    Secure API connectivity with banking systems,
                                    payment gateways, and fintech platforms.
                                </p>
                            </div>

                            <div className="service-box">
                                <div className="service-icon">☁</div>
                                <h3>Digital Transformation</h3>
                                <p>
                                    Cloud-native applications, automation,
                                    analytics, and scalable financial technology.
                                </p>
                            </div>

                        </div>

                    </div>

                </section>

                {/*=====================================================
                    WHY CLIENTS CHOOSE US
        ======================================================*/}

                <section className="about-why">

                    <div className="container">

                        <div className="section-heading">

                            <span className="section-tag">
                                WHY CHOOSE US
                            </span>

                            <h2>
                                Trusted by Financial
                                <span> Institutions</span>
                            </h2>

                        </div>

                        <div className="why-grid">

                            <div className="why-item">
                                <h3>🛡 Security First</h3>
                                <p>
                                    Enterprise-grade security designed to safeguard
                                    financial systems and customer information.
                                </p>
                            </div>

                            <div className="why-item">
                                <h3>📜 Compliance Driven</h3>
                                <p>
                                    AML, KYC, RBI, FATF, and regulatory compliance
                                    expertise across financial operations.
                                </p>
                            </div>

                            <div className="why-item">
                                <h3>☁ Cloud Native</h3>
                                <p>
                                    Modern cloud architecture that enables scalability,
                                    performance, and business continuity.
                                </p>
                            </div>

                            <div className="why-item">
                                <h3>⚡ Fast Integration</h3>
                                <p>
                                    Quick integration with banking APIs, payment
                                    platforms, and enterprise systems.
                                </p>
                            </div>

                            <div className="why-item">
                                <h3>👨‍💼 Expert Team</h3>
                                <p>
                                    Experienced fintech professionals focused on
                                    innovation, compliance, and operational excellence.
                                </p>
                            </div>

                            <div className="why-item">
                                <h3>📞 Dedicated Support</h3>
                                <p>
                                    Reliable support and continuous improvement for
                                    long-term client success.
                                </p>
                            </div>

                        </div>

                    </div>

                </section>

                {/*=====================================================
                    INDUSTRIES WE SERVE
        ======================================================*/}

                <section className="about-industries">

                    <div className="container">

                        <div className="section-heading">

                            <span className="section-tag">
                                INDUSTRIES WE SERVE
                            </span>

                            <h2>
                                Supporting Every Segment of
                                <span> Digital Finance</span>
                            </h2>

                            <p>
                                Our solutions are designed for organizations across the
                                financial ecosystem, helping them innovate securely and
                                remain compliant in a rapidly changing industry.
                            </p>

                        </div>

                        <div className="industry-grid">

                            <div className="industry-box">
                                🏦
                                <h3>Banks</h3>
                            </div>

                            <div className="industry-box">
                                💼
                                <h3>NBFCs</h3>
                            </div>

                            <div className="industry-box">
                                💳
                                <h3>Payment Providers</h3>
                            </div>

                            <div className="industry-box">
                                🛡
                                <h3>Insurance</h3>
                            </div>

                            <div className="industry-box">
                                📱
                                <h3>Digital Wallets</h3>
                            </div>

                            <div className="industry-box">
                                🚀
                                <h3>FinTech Startups</h3>
                            </div>

                        </div>

                    </div>

                </section>

                {/*=====================================================
                        OUR PROCESS
        ======================================================*/}

                <section className="about-process">

                    <div className="container">

                        <div className="section-heading">

                            <span className="section-tag">
                                OUR PROCESS
                            </span>

                            <h2>
                                Our Proven
                                <span> Delivery Approach</span>
                            </h2>

                            <p>
                                Every engagement follows a structured process that
                                ensures quality, security, compliance, and measurable
                                business outcomes.
                            </p>

                        </div>

                        <div className="process-grid">

                            <div className="process-card">

                                <div className="process-number">
                                    01
                                </div>

                                <h3>Consultation</h3>

                                <p>
                                    We understand your business goals, regulatory
                                    requirements, and technology challenges.
                                </p>

                            </div>

                            <div className="process-card">

                                <div className="process-number">
                                    02
                                </div>

                                <h3>Requirement Analysis</h3>

                                <p>
                                    Our experts analyze your operational needs and design
                                    the most suitable fintech strategy.
                                </p>

                            </div>

                            <div className="process-card">

                                <div className="process-number">
                                    03
                                </div>

                                <h3>Solution Design</h3>

                                <p>
                                    We architect secure, scalable, and compliance-ready
                                    fintech solutions tailored to your organization.
                                </p>

                            </div>

                            <div className="process-card">

                                <div className="process-number">
                                    04
                                </div>

                                <h3>Development & Integration</h3>

                                <p>
                                    Our team develops and integrates APIs, payment
                                    systems, automation, and cloud infrastructure.
                                </p>

                            </div>

                            <div className="process-card">

                                <div className="process-number">
                                    05
                                </div>

                                <h3>Testing & Compliance</h3>

                                <p>
                                    Every solution is validated through security testing,
                                    compliance checks, and performance optimization.
                                </p>

                            </div>

                            <div className="process-card">

                                <div className="process-number">
                                    06
                                </div>

                                <h3>Deployment & Support</h3>

                                <p>
                                    We ensure a smooth deployment followed by continuous
                                    monitoring, maintenance, and technical support.
                                </p>

                            </div>

                        </div>

                    </div>

                </section>

                {/*=====================================================
                        FINAL CTA
        ======================================================*/}

                <section className="about-cta">

                    <div className="container">

                        <div className="about-cta-box">

                            <span className="section-tag">
                                LET'S BUILD TOGETHER
                            </span>

                            <h2>
                                Ready to Transform Your
                                <span> Financial Business?</span>
                            </h2>

                            <p>
                                Whether you're a bank, NBFC, payment provider,
                                insurance company, or fintech startup, Saivari Fintech
                                is ready to help you build secure, scalable, and
                                compliance-driven digital solutions that support your
                                long-term growth.
                            </p>

                            <div className="about-cta-buttons">

                                <a
                                    href="/contact"
                                    className="primary-about-btn"
                                >
                                    Get Consultation
                                </a>

                                {/* <Link
                                    to="/services"
                                    className="secondary-about-btn"
                                >
                                    Explore Services
                                </Link> */}

                            </div>

                        </div>

                    </div>

                </section>

            </div>

            <Footer />

        </>
    );
};

export default About;